import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-pregunta-modal',
  templateUrl: './pregunta-modal.component.html'
})
export class PreguntaModalComponent implements OnInit {

  @Input() tituloModal: string;
  @Input() textoModal: string;
  @Input() preguntaModal: string;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
